'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Creates a normalized object of limits.
 * {
 *   Despoit: {
 *     type: 'Deposit',
 *     content: '',
 *     timespans: { 1: { currentLimit: {}, ... }, 7: { ... }, 30: { ... } },
 *   },
 *   NetLoss: { type: 'NetLoss', ... }
 * }
 * @param {Array} limits - Array of limits from api
 * @param {Object} content - Optional cms content
 */
var normalize = function normalize(limits, content) {
  return (content ? content.items.map(function (l) {
    return {
      type: l.config.type,
      product: l.config.product,
      contentLimit: l
    };
  }) : [].concat(_toConsumableArray(new Set(limits.map(function (l) {
    return l.Type;
  })))).map(function (type) {
    return { type: type };
  })).reduce(function (normalizedLimits, _ref) {
    var type = _ref.type,
        product = _ref.product,
        contentLimit = _ref.contentLimit;
    return _extends({}, normalizedLimits, _defineProperty({}, type, _extends({}, skeleton, defaultLimits[type], contentLimit ? _extends({}, contentLimit, { config: null }) : {}, contentLimit ? contentLimit.config : {}, normalizeLimits(type, limits.filter(function (l) {
      return product ? l.Product === product && l.Type === type : l.Type === type;
    })))));
  }, {});
};

var skeleton = {
  /**
   * Default timespans 1, 7, 30.
   */
  timespans: { 1: { timespan: 1 }, 7: { timespan: 7 }, 30: { timespan: 30 } },
  /**
   * Values displayed in the limit selector
   */
  values: { EUR: [30, 60, 120], GBP: [30, 60, 120], SEK: [300, 600, 1200] },
  /**
   * Currency, minutes, hours, days, months, years
   */
  valueType: 'currency',
  /**
   * Content displayed in tooltip
   */
  content: '',
  /**
   * Sets if tooltip should be open by default
   */
  tooltipOpen: false,
  /**
   * Hides the remaining limit
   */
  hideRemainingLimit: false,
  /**
   * Hides the "other" option in limit selector
   */
  hideOther: false,
  /**
   * Some limit type have an associated product
   */
  product: ''
};

/**
 * Default limits for each type. Overrides the skeleton default.
 */
var defaultLimits = {
  Deposit: {
    type: 'Deposit'
  },
  NetLoss: {
    type: 'NetLoss'
  },
  Wager: {
    type: 'Wager'
  },
  Session: {
    type: 'Session',
    values: [30, 60, 120],
    valueType: 'minutes'
  },
  RealityCheck: {
    type: 'RealityCheck',
    values: [30, 60, 120],
    valueType: 'minutes'
  },
  LoginTime: {
    type: 'LoginTime',
    values: [1, 7, 30],
    valueType: 'hours'
  },
  ProductSession: {
    type: 'ProductSession',
    product: 'Casino',
    values: [2500, 5000, 10000],
    valueType: 'minutes'
  },
  Block: {
    type: 'Block',
    timespans: { 1: { timespan: 1 } },
    values: [1, 7, 30],
    valueType: 'days',
    tooltipOpen: true
  },
  SelfExclude: {
    type: 'SelfExclude',
    timespans: { 1: { timespan: 1 } },
    values: [1, 7, 30],
    valueType: 'days'
  }
};

/**
 * Group limits by type and timespan.
 * Set currentLimit, pendingLimit etc
 * for each type/timespan combination
 * @param {String} type - The type of the limits in the limits array
 * @param {Array} limits - Array of limits with the same type
 */
var normalizeLimits = function normalizeLimits(type, limits) {
  var x3timespans = ['Deposit', 'NetLoss', 'Wager', 'LoginTime', 'ProductSession'].includes(type);

  var timespans = x3timespans ? {
    1: normalizeTimespan(1, limits.filter(function (l) {
      return l.Timespan === 1;
    })),
    7: normalizeTimespan(7, limits.filter(function (l) {
      return l.Timespan === 7;
    })),
    30: normalizeTimespan(30, limits.filter(function (l) {
      return l.Timespan === 30;
    }))
  } : {
    1: normalizeTimespan(1, limits)
  };

  // Add legacy timespans if they exist on player account
  if (x3timespans && limits.filter(function (l) {
    return l.Timespan === 0;
  }).length > 0) timespans[0] = normalizeTimespan(0, limits.filter(function (l) {
    return l.Timespan === 0;
  }));

  return {
    type: type,
    timespans: timespans
  };
};

/**
 * Given an array of limits of the same type, this function will
 * determine activeLimit, canceledlimit, currentLimit etc.
 * @param {Number} timespan - The timespan of the limits in the limits array
 * @param {Array} limits - Array of limits with the same timespan
 */
var normalizeTimespan = function normalizeTimespan(timespan, limits) {
  var adminLimit = limits.find(function (l) {
    return l.IsAdmin;
  });

  limits = limits.filter(function (l) {
    return !l.IsAdmin;
  });
  limits.sort(function (a, b) {
    return a.Amount - b.Amount;
  });

  var activeLimit = limits.find(function (l) {
    return l.Status === 'Active';
  });
  var canceledLimit = limits.find(function (l) {
    return l.Status === 'Canceled';
  });
  var newLimit = limits.find(function (l) {
    return l.Status === 'NewLimit';
  });
  var reviewLimit = limits.find(function (l) {
    return l.Status === 'Review';
  });

  /**
   * currentLimit is the limit currently active for the user
   */
  var currentLimitCandidates = [activeLimit, canceledLimit];
  currentLimitCandidates.sort(function (a, b) {
    return a.Amount - b.Amount;
  });
  var currentLimit = currentLimitCandidates[0];

  /**
   * Pending limits waiting to become activated or removed
   */
  var pendingActivateLimit = limits.find(function (l) {
    return ['Active', 'Cooldown'].includes(l.Status) && l.Activates;
  }) || reviewLimit;
  var pendingDeleteLimit = limits.find(function (l) {
    return l.Status === 'Canceled' && l.Expires;
  });

  /**
   * Some users have more than one active limit
   * If pickLimits.length > 1, user needs to pick a limit
   */
  var pickLimits = limits.filter(function (l) {
    return l.Status === 'Active';
  });

  /**
   * Confirm limit is a pendingActivate or pendingDelete whose Expires has passed
   * User need to confirm the pending limit before it activates
   */
  var confirmLimit = pendingActivateLimit && pendingActivateLimit.Expires && Date.now() > Date.parse(pendingActivateLimit.Expires + '+00:00') && pendingActivateLimit || pendingDeleteLimit && pendingDeleteLimit.Expires && Date.now() > Date.parse(pendingDeleteLimit.Expires + '+00:00') && pendingDeleteLimit || null;

  return {
    timespan: timespan,
    currentLimit: currentLimit,
    newLimit: newLimit,
    pendingActivateLimit: pendingActivateLimit,
    pendingDeleteLimit: pendingDeleteLimit,
    pickLimits: pickLimits,
    confirmLimit: confirmLimit,
    adminLimit: adminLimit
  };
};

exports.default = normalize;